import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { cn } from '../../../lib/utils';
import { SETTINGS_SECTIONS } from '../constants';
export function SettingsSidebar({ activeSection, onSectionChange }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex-shrink-0 lg:w-64",
        children: /*#__PURE__*/ _jsx("nav", {
            className: "space-y-0.5",
            "data-testid": Testids.settings.nav,
            children: SETTINGS_SECTIONS.map((section)=>{
                const Icon = section.icon;
                const active = activeSection === section.id;
                return /*#__PURE__*/ _jsxs("button", {
                    "aria-current": active ? 'page' : undefined,
                    className: cn('flex w-full items-center rounded-md px-3 py-2 text-sm font-medium transition-colors', active ? 'bg-secondary text-secondary-foreground' : 'text-muted-foreground hover:bg-muted hover:text-foreground'),
                    onClick: ()=>onSectionChange(section.id),
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            className: "mr-3 h-4 w-4 flex-shrink-0"
                        }),
                        section.label
                    ]
                }, section.id);
            })
        })
    });
}
